import SvgWrapper from './SvgWrapper';
import { AllergnIconProps } from './types';

const SoyaIcon = ({
  innerColor = '#fefefe',
  outerColor = '#009a4c',
  ...props
}: AllergnIconProps) => {
  const style = {
    fill: innerColor,
  };

  return (
    <SvgWrapper {...props}>
      <g
        id="Grupo_122"
        data-name="Grupo 122"
        transform="translate(-150.5 -2094)"
      >
        <g
          id="Rectángulo_17"
          data-name="Rectángulo 17"
          transform="translate(150.5 2094)"
          fill="#fff"
          stroke="#000"
          stroke-width="1"
        >
          <rect width="27" height="27" rx="2" stroke="none" />
          <rect x="0.5" y="0.5" width="26" height="26" rx="1.5" fill="none" />
        </g>
        <g id="soya" transform="translate(157.04 2100.54)">
          <g
            id="Grupo_92"
            data-name="Grupo 92"
            transform="translate(4.922 4.922)"
          >
            <path
              id="Trazado_9094"
              data-name="Trazado 9094"
              d="M181.631,184.515a2.039,2.039,0,1,1,2.884,0A2.042,2.042,0,0,1,181.631,184.515Zm2.307-2.307a1.224,1.224,0,1,0,0,1.73A1.225,1.225,0,0,0,183.939,182.208Z"
              transform="translate(-181.035 -181.035)"
            />
          </g>
          <g
            id="Grupo_93"
            data-name="Grupo 93"
            transform="translate(9.844 9.844)"
          >
            <path
              id="Trazado_9095"
              data-name="Trazado 9095"
              d="M362.666,365.55a2.039,2.039,0,1,1,2.884,0A2.041,2.041,0,0,1,362.666,365.55Zm2.307-2.307a1.224,1.224,0,1,0,0,1.73A1.225,1.225,0,0,0,364.973,363.243Z"
              transform="translate(-362.07 -362.07)"
            />
          </g>
          <g
            id="Grupo_94"
            data-name="Grupo 94"
            transform="translate(8.423 1.694)"
          >
            <path
              id="Trazado_9096"
              data-name="Trazado 9096"
              d="M310.333,65.537a1.9,1.9,0,1,1,2.692,0A1.905,1.905,0,0,1,310.333,65.537Zm2.115-2.115a1.088,1.088,0,1,0,0,1.538A1.089,1.089,0,0,0,312.448,63.423Z"
              transform="translate(-309.776 -62.289)"
            />
          </g>
          <g
            id="Grupo_95"
            data-name="Grupo 95"
            transform="translate(1.694 8.423)"
          >
            <path
              id="Trazado_9097"
              data-name="Trazado 9097"
              d="M62.846,313.024a1.9,1.9,0,1,1,2.692,0A1.905,1.905,0,0,1,62.846,313.024Zm2.115-2.115a1.088,1.088,0,1,0,0,1.538A1.089,1.089,0,0,0,64.961,310.91Z"
              transform="translate(-62.289 -309.776)"
            />
          </g>
          <g id="Grupo_96" data-name="Grupo 96" transform="translate(0 0)">
            <path
              id="Trazado_9098"
              data-name="Trazado 9098"
              d="M.255,13.665a1.028,1.028,0,0,1-.216-1A3.842,3.842,0,0,0,.1,11.028,3.534,3.534,0,0,1,3.282,6.809,3.67,3.67,0,0,1,6.808,3.283,3.534,3.534,0,0,1,11.028.106,3.842,3.842,0,0,0,12.667.04a1.028,1.028,0,0,1,1,.216,1.028,1.028,0,0,1,.215,1,3.842,3.842,0,0,0-.065,1.64,3.534,3.534,0,0,1-3.178,4.219,3.67,3.67,0,0,1-3.526,3.526,3.534,3.534,0,0,1-4.219,3.178,3.842,3.842,0,0,0-1.64.065,1.028,1.028,0,0,1-1-.216ZM13.087.833a.347.347,0,0,0-.234,0,4.635,4.635,0,0,1-1.984.071A2.72,2.72,0,0,0,7.613,3.682a.408.408,0,0,1-.438.422A2.857,2.857,0,0,0,4.1,7.176a.408.408,0,0,1-.422.438A2.72,2.72,0,0,0,.9,10.87a4.636,4.636,0,0,1-.071,1.984.347.347,0,0,0,0,.234.347.347,0,0,0,.234,0,4.635,4.635,0,0,1,1.984-.071,2.72,2.72,0,0,0,3.256-2.777.408.408,0,0,1,.438-.422A2.857,2.857,0,0,0,9.816,6.745a.408.408,0,0,1,.422-.438,2.72,2.72,0,0,0,2.777-3.256,4.636,4.636,0,0,1,.071-1.984.347.347,0,0,0,0-.234Z"
              transform="translate(0.001 0)"
            />
          </g>
        </g>
      </g>
    </SvgWrapper>
  );
};

export default SoyaIcon;
